<template>
  <div
    v-if="version === 'v1'"
    class="property-list-item tw-flex tw-flex-col tw-text-start md:tw-min-h-[600px]"
    :class="{
      'tw-col-span-4': colSpan === 4,
      'tw-col-span-6': colSpan === 6,
      'tw-col-span-12': colSpan === 12,
    }"
    style="border-radius: var(--rounded); background-color: var(--c-card)"
  >
    <nuxt-link :external="true" :to="property.detail_page_url" class="n-link tw-group tw-relative">
      <div class="tw-relative tw-overflow-hidden">
        <library-image :src="property.image" :quality="60" style="border-radius: var(--rounded)" />
        <div
          class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-50"
          style="border-radius: var(--rounded)"
        ></div>
        <div
          class="tw-absolute tw-inset-0 -tw-bottom-[100px] tw-flex tw-items-end tw-justify-center tw-opacity-0 tw-transition-all tw-duration-500 group-hover:tw-bottom-0 group-hover:tw-opacity-100"
        >
          <p class="n-semibold tw-mb-6" style="color: var(--c-text-white)">View this property</p>
        </div>
      </div>
      <button v-if="property.custom_property_status_title" class="nc-property-image-badge n-primary">
        {{ property.custom_property_status_title }}
      </button>

      <div class="tw-flex tw-h-[64px] tw-items-center tw-justify-between tw-px-4 tw-pt-2">
        <div class="tw-flex tw-flex-col">
          <p class="tw-flex tw-h-full tw-items-center tw-uppercase">
            {{ property.price.type.name ? property.price.type.name : '\u00A0' }}
          </p>
          <h6 class="tw-flex tw-h-full tw-items-center">
            {{ property.price.price }}
          </h6>
        </div>
        <div v-if="property.match_percentage && !isMatchInformationHidden" class="tw-flex tw-items-center tw-gap-2">
          <button
            class="n-primary !tw-cursor-default !tw-px-2 !tw-py-1 hover:!tw-bg-[var(--c-primary)] hover:!tw-text-[var(--c-text-secondary)]"
          >
            <p>{{ property.match_percentage }} MATCH</p>
          </button>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-4 tw-px-4 tw-py-4">
        <h5 class="tw-line-clamp-3 tw-h-[5.8rem]">{{ property.advert_heading }}</h5>

        <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
          <p class="tw-flex tw-items-center tw-gap-2">
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.125 6.6875C4.125 5.77582 4.48716 4.90148 5.13182 4.25682C5.77648 3.61216 6.65082 3.25 7.5625 3.25H14.4375C15.3492 3.25 16.2235 3.61216 16.8682 4.25682C17.5128 4.90148 17.875 5.77582 17.875 6.6875V8.81875C18.6514 8.97724 19.3493 9.39913 19.8504 10.013C20.3515 10.6269 20.6252 11.3951 20.625 12.1875V19.0625C20.625 19.2448 20.5526 19.4197 20.4236 19.5486C20.2947 19.6776 20.1198 19.75 19.9375 19.75C19.7552 19.75 19.5803 19.6776 19.4514 19.5486C19.3224 19.4197 19.25 19.2448 19.25 19.0625V15.625H2.75V19.0625C2.75 19.2448 2.67757 19.4197 2.54864 19.5486C2.4197 19.6776 2.24484 19.75 2.0625 19.75C1.88016 19.75 1.7053 19.6776 1.57636 19.5486C1.44743 19.4197 1.375 19.2448 1.375 19.0625V12.1875C1.37484 11.3951 1.64848 10.6269 2.1496 10.013C2.65073 9.39913 3.34856 8.97724 4.125 8.81875V6.6875ZM2.75 14.25H19.25V12.1875C19.25 11.6405 19.0327 11.1159 18.6459 10.7291C18.2591 10.3423 17.7345 10.125 17.1875 10.125H4.8125C4.26549 10.125 3.74089 10.3423 3.35409 10.7291C2.9673 11.1159 2.75 11.6405 2.75 12.1875V14.25ZM16.5 6.6875C16.5 6.14049 16.2827 5.61589 15.8959 5.22909C15.5091 4.8423 14.9845 4.625 14.4375 4.625H7.5625C7.01549 4.625 6.49089 4.8423 6.10409 5.22909C5.7173 5.61589 5.5 6.14049 5.5 6.6875V8.75H6.875V8.0625C6.875 7.88016 6.94743 7.7053 7.07636 7.57636C7.2053 7.44743 7.38016 7.375 7.5625 7.375H9.625C9.80734 7.375 9.9822 7.44743 10.1111 7.57636C10.2401 7.7053 10.3125 7.88016 10.3125 8.0625V8.75H11.6875V8.0625C11.6875 7.88016 11.7599 7.7053 11.8889 7.57636C12.0178 7.44743 12.1927 7.375 12.375 7.375H14.4375C14.6198 7.375 14.7947 7.44743 14.9236 7.57636C15.0526 7.7053 15.125 7.88016 15.125 8.0625V8.75H16.5V6.6875Z"
                fill="var(--c-icon)"
              />
            </svg>
            <span class="tw-font-bold">{{ property.bedroom }}</span>
          </p>
          <p class="tw-flex tw-items-center tw-gap-1">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.9184 3.58042C20.4813 3.14492 19.8895 2.90039 19.2726 2.90039C18.6556 2.90039 18.0638 3.14492 17.6268 3.58042L15.1752 6.02602L15.168 6.03322C13.8546 5.38969 12.3763 5.16143 10.93 5.3788C9.48364 5.59617 8.1378 6.24886 7.07157 7.25002C6.5875 7.14826 6.08352 7.20559 5.63467 7.41345C5.18582 7.62131 4.81611 7.9686 4.58061 8.40359C4.34511 8.83857 4.25641 9.338 4.32773 9.82747C4.39904 10.317 4.62655 10.7703 4.97637 11.12L13.38 19.5248C13.7298 19.875 14.1834 20.1028 14.6732 20.1741C15.1631 20.2455 15.6628 20.1566 16.098 19.9207C16.5332 19.6848 16.8805 19.3146 17.0881 18.8653C17.2957 18.4159 17.3525 17.9115 17.25 17.4272C18.2512 16.3608 18.9038 15.0146 19.121 13.568C19.3381 12.1215 19.1095 10.643 18.4656 9.32962L18.4728 9.32122L20.9184 6.88162C21.1359 6.66528 21.3085 6.40808 21.4263 6.12482C21.5441 5.84155 21.6047 5.53779 21.6047 5.23102C21.6047 4.92424 21.5441 4.62048 21.4263 4.33721C21.3085 4.05395 21.1359 3.79675 20.9184 3.58042ZM17.8272 8.27122C17.3816 7.65706 16.8417 7.1172 16.2276 6.67162L18.474 4.43002C18.578 4.3199 18.703 4.23178 18.8417 4.17089C18.9804 4.11 19.1299 4.07757 19.2813 4.07552C19.4328 4.07347 19.5831 4.10185 19.7234 4.15897C19.8637 4.21609 19.9911 4.30079 20.098 4.40805C20.2049 4.51532 20.2893 4.64296 20.346 4.78341C20.4027 4.92386 20.4306 5.07427 20.4281 5.22571C20.4256 5.37716 20.3927 5.52656 20.3314 5.66506C20.2701 5.80356 20.1816 5.92834 20.0712 6.03202L17.8272 8.27122ZM8.20197 7.85362C9.35357 6.91133 10.8142 6.43057 12.3003 6.50467C13.7865 6.57877 15.192 7.20243 16.2442 8.25459C17.2964 9.30674 17.92 10.7123 17.9941 12.1984C18.0682 13.6846 17.5875 15.1452 16.6452 16.2968L16.626 16.2776L8.22237 7.87402L8.20197 7.85362ZM7.34517 8.69362L15.8052 17.1548C16.0069 17.3639 16.1174 17.6446 16.1122 17.9351C16.107 18.2257 15.9867 18.5022 15.7776 18.704C15.5685 18.9058 15.2878 19.0162 14.9973 19.0111C14.7067 19.0059 14.4301 18.8855 14.2284 18.6764L5.82357 10.2716C5.62377 10.0678 5.51137 9.79413 5.51029 9.50873C5.5092 9.22334 5.61953 8.94879 5.81778 8.7435C6.01604 8.53821 6.28658 8.41838 6.57183 8.40951C6.85709 8.40065 7.13455 8.50344 7.34517 8.69602M8.22357 16.2788C8.33605 16.3913 8.39924 16.5439 8.39924 16.703C8.39924 16.8621 8.33605 17.0147 8.22357 17.1272L5.82357 19.5272C5.71107 19.6399 5.55841 19.7032 5.3992 19.7033C5.23998 19.7035 5.08724 19.6403 4.97457 19.5278C4.86191 19.4153 4.79855 19.2627 4.79844 19.1034C4.79833 18.9442 4.86147 18.7915 4.97397 18.6788L7.37397 16.2788C7.42971 16.2229 7.49592 16.1786 7.56881 16.1484C7.64171 16.1181 7.71985 16.1025 7.79877 16.1025C7.87769 16.1025 7.95584 16.1181 8.02873 16.1484C8.10163 16.1786 8.16784 16.2229 8.22357 16.2788ZM5.82357 14.7272C5.87928 14.6714 5.92345 14.6052 5.95357 14.5324C5.98369 14.4595 5.99916 14.3814 5.9991 14.3026C5.99905 14.2238 5.98347 14.1457 5.95324 14.0729C5.92302 14.0001 5.87876 13.9339 5.82297 13.8782C5.76719 13.8225 5.70097 13.7783 5.62812 13.7482C5.55526 13.7181 5.47718 13.7026 5.39835 13.7027C5.31951 13.7027 5.24146 13.7183 5.16864 13.7485C5.09583 13.7788 5.02968 13.823 4.97397 13.8788L2.57397 16.2788C2.51826 16.3346 2.47409 16.4008 2.44397 16.4737C2.41385 16.5465 2.39838 16.6246 2.39844 16.7034C2.39849 16.7823 2.41408 16.8603 2.4443 16.9331C2.47452 17.006 2.51879 17.0721 2.57457 17.1278C2.63036 17.1835 2.69657 17.2277 2.76943 17.2578C2.84228 17.2879 2.92036 17.3034 2.9992 17.3033C3.07803 17.3033 3.15609 17.2877 3.2289 17.2575C3.30172 17.2273 3.36786 17.183 3.42357 17.1272L5.82357 14.7272ZM10.6236 18.6788C10.7361 18.7913 10.7992 18.9439 10.7992 19.103C10.7992 19.2621 10.7361 19.4147 10.6236 19.5272L8.22357 21.9272C8.11107 22.0399 7.95841 22.1032 7.7992 22.1033C7.63998 22.1035 7.48724 22.0403 7.37457 21.9278C7.26191 21.8153 7.19855 21.6627 7.19844 21.5034C7.19833 21.3442 7.26147 21.1915 7.37397 21.0788L9.77397 18.6788C9.82971 18.6229 9.89592 18.5786 9.96881 18.5484C10.0417 18.5181 10.1199 18.5025 10.1988 18.5025C10.2777 18.5025 10.3558 18.5181 10.4287 18.5484C10.5016 18.5786 10.5678 18.6229 10.6236 18.6788Z"
                fill="var(--c-icon)"
              />
            </svg>
            <span class="tw-font-bold">{{ property.bathroom }}</span>
          </p>
          <p class="tw-flex tw-items-center tw-gap-1">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.25 4.5C6.52065 4.5 5.82118 4.78973 5.30546 5.30546C4.78973 5.82118 4.5 6.52065 4.5 7.25V8.587C3.78808 8.75585 3.15396 9.15998 2.70027 9.734C2.24657 10.308 1.99984 11.0183 2 11.75V14.75C1.9999 15.4361 2.2563 16.0975 2.71886 16.6043C3.18142 17.1111 3.81671 17.4266 4.5 17.489V18.75C4.5 18.9489 4.57902 19.1397 4.71967 19.2803C4.86032 19.421 5.05109 19.5 5.25 19.5C5.44891 19.5 5.63968 19.421 5.78033 19.2803C5.92098 19.1397 6 18.9489 6 18.75V17.5H18V18.75C18 18.9489 18.079 19.1397 18.2197 19.2803C18.3603 19.421 18.5511 19.5 18.75 19.5C18.9489 19.5 19.1397 19.421 19.2803 19.2803C19.421 19.1397 19.5 18.9489 19.5 18.75V17.489C20.1833 17.4266 20.8186 17.1111 21.2811 16.6043C21.7437 16.0975 22.0001 15.4361 22 14.75V11.75C22.0002 11.0183 21.7534 10.308 21.2997 9.734C20.846 9.15998 20.2119 8.75585 19.5 8.587V7.25C19.5 6.52065 19.2103 5.82118 18.6945 5.30546C18.1788 4.78973 17.4793 4.5 16.75 4.5H7.25ZM19.25 16H4.75C4.06 16 3.5 15.44 3.5 14.75V11.75C3.5 11.2859 3.68437 10.8408 4.01256 10.5126C4.34075 10.1844 4.78587 10 5.25 10C5.71413 10 6.15925 10.1844 6.48744 10.5126C6.81563 10.8408 7 11.2859 7 11.75V12.25C7 12.664 7.336 13 7.75 13H16.25C16.4489 13 16.6397 12.921 16.7803 12.7803C16.921 12.6397 17 12.4489 17 12.25V11.75C17 11.2859 17.1844 10.8408 17.5126 10.5126C17.8408 10.1844 18.2859 10 18.75 10C19.2141 10 19.6592 10.1844 19.9874 10.5126C20.3156 10.8408 20.5 11.2859 20.5 11.75V14.75C20.5 15.44 19.94 16 19.25 16ZM18 8.587C17.3298 8.74604 16.7275 9.11389 16.28 9.63746C15.8324 10.161 15.5628 10.8132 15.51 11.5H8.49C8.43719 10.8132 8.16756 10.161 7.72002 9.63746C7.27248 9.11389 6.67017 8.74604 6 8.587V7.25C6 6.56 6.56 6 7.25 6H16.75C17.44 6 18 6.56 18 7.25V8.587Z"
                fill="var(--c-icon)"
              />
            </svg>

            <span class="tw-font-bold">{{ property.reception }}</span>
          </p>
        </div>
        <div class="tw-flex tw-h-16 tw-flex-row tw-items-start tw-gap-2">
          <p>{{ property.display_address }}</p>
        </div>
      </div>
    </nuxt-link>
  </div>

  <div
    v-if="version === 'v2'"
    class="property-list-item shine-effect tw-flex tw-flex-col tw-text-start md:tw-min-h-[600px]"
    :class="{
      'tw-col-span-4': colSpan === 4,
      'tw-col-span-6': colSpan === 6,
      'tw-col-span-12': colSpan === 12,
    }"
    style="border-radius: var(--rounded); background-color: var(--c-card)"
  >
    <nuxt-link :external="true" :to="property.detail_page_url" class="n-link tw-group tw-relative">
      <div class="tw-relative tw-overflow-hidden">
        <library-image :src="property.image" :quality="60" style="border-radius: var(--rounded)" />
        <div
          class="shine tw-absolute tw-inset-0 tw-bg-black tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-50"
          style="border-radius: var(--rounded)"
        ></div>
        <div
          class="tw-absolute tw-inset-0 -tw-bottom-[100px] tw-flex tw-items-end tw-justify-center tw-text-white tw-opacity-0 tw-transition-all tw-duration-500 group-hover:tw-bottom-0 group-hover:tw-opacity-100"
        >
          <span class="tw-mb-6 !tw-uppercase">View this home</span>
        </div>
      </div>
      <button v-if="property.custom_property_status_title" class="nc-property-image-badge n-primary">
        {{ property.custom_property_status_title }}
      </button>

      <div class="tw-mt-4 tw-flex tw-h-[72px] tw-items-center tw-justify-between tw-p-2">
        <div>
          <span class="tw-flex tw-h-full tw-items-center tw-uppercase">
            {{ property.price.type.name ? property.price.type.name : '\u00A0' }}
          </span>
          <h5 class="tw-flex tw-h-full tw-items-center">
            {{ property.price.price }}
          </h5>
        </div>
        <div v-if="property.match_percentage && !isMatchInformationHidden" class="tw-flex tw-items-center tw-gap-2">
          <button
            class="n-primary !tw-cursor-default !tw-px-2 !tw-py-1 hover:!tw-bg-[var(--c-secondary)] hover:!tw-text-white"
          >
            <p>{{ property.match_percentage }} MATCH</p>
          </button>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-4 tw-px-2 tw-pt-4">
        <h6 class="tw-line-clamp-2 tw-h-[4.4rem]">
          {{ property.advert_heading }}
        </h6>

        <div class="tw-flex tw-h-12 tw-flex-row tw-items-start tw-gap-2 tw-text-[var(--c-tertiary)]">
          <span>{{ property.display_address }}</span>
        </div>
        <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
          <p class="tw-flex tw-items-center tw-gap-1">
            <span class="tw-font-bold">{{ property.bedroom }}</span>
            <span>BED</span>
          </p>
          <p class="tw-flex tw-items-center tw-gap-1">
            <span class="tw-font-bold">{{ property.bathroom }}</span>
            <span>BATH</span>
          </p>
          <p class="tw-flex tw-items-center tw-gap-1">
            <span class="tw-font-bold">{{ property.reception }}</span>
            <span>REC</span>
          </p>
        </div>
      </div>
    </nuxt-link>
  </div>

  <div
    v-if="version === 'v2Properties'"
    class="property-list-item tw-flex tw-flex-col tw-pb-12 tw-text-start"
    style="border-radius: var(--rounded); background-color: var(--c-card)"
  >
    <div class="tw-grid tw-grid-cols-12 tw-gap-8">
      <div class="tw-col-span-12 xl:tw-col-span-6">
        <div class="tw-grid tw-grid-cols-12 tw-gap-2">
          <div class="tw-col-span-12 md:tw-col-span-8">
            <nuxt-link :external="true" :to="property.detail_page_url" class="n-link tw-relative tw-border-0">
              <library-image
                :src="property.image"
                :quality="60"
                :w-ratio="3"
                :h-ratio="2"
                style="border-radius: var(--rounded)"
              />
              <button v-if="property.custom_property_status_title" class="nc-property-image-badge n-primary">
                {{ property.custom_property_status_title }}
              </button>
            </nuxt-link>
          </div>
          <div class="tw-col-span-12 tw-flex tw-gap-2 md:tw-col-span-4 md:tw-flex-col">
            <nuxt-link :external="true" :to="property.detail_page_url" class="n-link">
              <library-image
                :src="property.images[1].background"
                :quality="60"
                :w-ratio="3"
                :smWRatio="3.25"
                :h-ratio="1.98"
                :smHRatio="1.25"
                style="border-radius: var(--rounded)"
              />
            </nuxt-link>
            <nuxt-link :external="true" :to="property.detail_page_url" class="n-link">
              <library-image
                :src="property.images[2].background"
                :quality="60"
                :w-ratio="3"
                :smWRatio="3.25"
                :h-ratio="1.98"
                :smHRatio="1.25"
                style="border-radius: var(--rounded)"
            /></nuxt-link>
          </div>
        </div>
      </div>
      <div class="property-list-item-info tw-col-span-12 tw-flex tw-flex-col tw-gap-4 xl:tw-col-span-6">
        <div class="tw-flex tw-h-[72px] tw-items-center tw-justify-between">
          <div class="">
            <p class="tw-flex tw-h-full tw-items-center !tw-font-bold tw-uppercase">
              {{ property.price.type.name ? property.price.type.name : '\u00A0' }}
            </p>
            <h6 class="tw-flex tw-h-full tw-items-center !tw-font-bold">
              {{ property.price.price }}
            </h6>
          </div>
          <div v-if="property.match_percentage && !isMatchInformationHidden" class="tw-flex tw-items-center tw-gap-2">
            <button
              class="n-primary !tw-cursor-default !tw-px-2 !tw-py-1 hover:!tw-bg-[var(--c-secondary)] hover:!tw-text-white"
            >
              <p>{{ property.match_percentage }} MATCH</p>
            </button>
          </div>
        </div>

        <div class="info tw-flex tw-flex-col">
          <nuxt-link :external="true" :to="property.detail_page_url" class="n-link">
            <h5 class="tw-line-clamp-2 md:tw-h-[2.1rem]">
              {{ property.advert_heading }}
            </h5>
          </nuxt-link>
          <div class="tw-mt-2 tw-flex tw-h-14 tw-flex-row tw-items-start tw-gap-2">
            <p style="font-weight: 700 !important; color: var(--c-tertiary)">{{ property.display_address }}</p>
          </div>

          <div class="rooms tw-flex tw-flex-row tw-items-center tw-gap-4">
            <p class="tw-flex tw-items-center tw-gap-1">
              <span class="tw-font-bold">{{ property.bedroom }}</span>
              BED
            </p>
            <p class="tw-flex tw-items-center tw-gap-1">
              <span class="tw-font-bold">{{ property.bathroom }}</span>
              BATH
            </p>
            <p class="tw-flex tw-items-center tw-gap-1">
              <span class="tw-font-bold">{{ property.reception }}</span>
              REC
            </p>
          </div>

          <nuxt-link
            :external="true"
            :to="property.detail_page_url"
            class="n-link n-secondary tw-mt-10 tw-w-fit 2xl:tw-mt-20"
          >
            VIEW MORE DETAILS
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { PropertyItemComponent } from '~/units/properties/types';
import NcTooltip from '~/components/common/NcTooltip.vue';

export default defineNuxtComponent({
  name: 'PropertyListItem',

  components: { NcTooltip },

  props: {
    property: {
      required: true,
      type: Object as PropType<PropertyItemComponent>,
    },

    isMatchInformationHidden: {
      required: false,
      type: Boolean,
      default: false,
    },

    version: {
      required: false,
      type: String,
      default: 'v1',
    },

    preMarketPropertyFeature: {
      required: false,
      type: Boolean,
      default: false,
    },

    colSpan: {
      required: false,
      type: Number,
      default: 4,
    },

    isLetterPropertyCriteria: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
});
</script>
